import { takeLatest, call, put } from 'redux-saga/effects';
import { GET_FAQ_START, POST_FAQ_ERROR, POST_FAQ_START, POST_FAQ_SUCCESS } from '../../types';

import apiCall from '../../../api';

export function* create({ payload }) {
  try {
    const url = '/faqs/create';
    const method = 'POST';
    const data = payload.data;
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, data, headers);
    console.log(results)
    yield put({ type: POST_FAQ_SUCCESS, results: results.data });
  } catch (error) {
    console.log(error)
    yield put({ type: POST_FAQ_ERROR, error });
  } finally {
    yield put({ type: GET_FAQ_START, payload: {lang: null, token: payload.token} });
    payload.navigate(-1);
  }
}

export default function* post_faqs() {
    yield takeLatest(POST_FAQ_START, create);
}